var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('p',[_vm._v("404")]),_c('v-btn',{attrs:{"color":"primary","text":"","to":"/"}},[_vm._v(_vm._s(_vm.$t('notFound.back')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }